import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthAside } from "../components/AuthAside";
import { IS_MOCK } from "../api/client";
import "../styles/auth.css";

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState(IS_MOCK ? "dev@studio.gg" : "");
  const [password, setPassword] = useState(IS_MOCK ? "demo" : "");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, password);
      nav("/app");
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card">
          <h1>Welcome back.</h1>
          <p className="sub">Sign in to your Laddr dashboard.</p>

          <form className="auth-form" onSubmit={submit}>
            {err && <div className="auth-err">{err}</div>}
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" className="input" type="email" autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="field">
              <label htmlFor="pw">Password</label>
              <input id="pw" className="input" type="password" autoComplete="current-password"
                value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button className="btn btn-primary" disabled={busy} style={{ justifyContent: "center" }}>
              {busy ? <span className="spinner" /> : "Sign in →"}
            </button>
          </form>

          {IS_MOCK && (
            <div className="mock-note">
              mock mode — any email/password works. Prefilled with the demo account.
            </div>
          )}

          <p className="auth-foot">
            New here? <Link to="/register">Create an account</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
